<template>
  <div class="payments responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'payments', label: 'Payment' },
        ]"
        :entity="entity"
        :hideAddButton="true"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter"/>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "payments",
  data() {
    return {
      listPageHeader,
      entity: Entities.PAYMENT,
    };
  },
  mounted: function () {
    this.setPageTitle("Payment");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "paymentModule/sort",
      pagination: "paymentModule/pagination",
      initialFilter: "paymentModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "paymentModule/updateSort",
      updatePagination: "paymentModule/updatePagination",
      updateInitialFilter: "paymentModule/updateInitialFilter"
    }),
  }
};
</script>
